<input :type="type" placeholder="Select Date..." :value="state.formatted" @input="emitUpdate($event.target)">